import React from 'react';

import { IChatMessage } from '../types';
import styles from '../berryChat.module.scss';

interface ChatMessageProps {
  message: IChatMessage;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  const bubbleClass = [
    styles.bubble,
    isUser ? styles.userBubble : styles.assistantBubble,
    message.isError ? styles.errorBubble : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`${styles.messageRow} ${isUser ? styles.userRow : styles.assistantRow}`}>
      <div className={bubbleClass}>
        <p className={styles.bubbleText}>{message.text}</p>
      </div>
    </div>
  );
};

export default ChatMessage;
